/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IHttpService, ILogService, IPromise} from 'angular';
import TSCockpitTypeDTO from '../../models/TSCockpitTypeDTO';
import TSCockpitResultDTO from '../../models/TSCockpitResultDTO';
import ITranslateService = angular.translate.ITranslateService;

export default class CockpitRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API', '$log', '$translate'];

    /* @ngInject */
    constructor($http: IHttpService, REST_API: string, private $log: ILogService, private $translate: ITranslateService) {
        this.serviceURL = REST_API + 'cockpit';
        this.http = $http;
    }

    public searchCockpitResult(cockpitTypeDTO: TSCockpitTypeDTO): IPromise<TSCockpitResultDTO> {

        cockpitTypeDTO.locale = this.$translate.use();
        let sentDto = {};
        sentDto = cockpitTypeDTO.serialize(sentDto);
        return this.http.post(this.serviceURL + '/search/', sentDto, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((response: any) => {
            this.$log.debug('PARSING result REST array object', response.data);
            return new TSCockpitResultDTO().deserialize(response.data);
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/cockpitRS.rest.ts